module.exports = __webpack_public_path__ + "static/img/材料简介.2db4832.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/materialDev/材料简介.jpg
// module id = 1+rD
// module chunks = 1